export enum ResponsiveType {
  Scroll,
  Accordion
}
